export default {
  setContacts: (state, payload) => {
    state.contacts = payload;
  },
};
